import type { Variants } from "framer-motion";

export type HeroEntranceConfig = {
  rotateZ: number;
  originX: number;
  originY: number;
  originZ: number;
};

export const HERO_ENTRANCE_DELAY = 0;
export const HERO_ENTRANCE_DURATION = 1.25;
export const HERO_ENTRANCE_FINAL_SCALE = 1.08;
export const HERO_ENTRANCE_PERSPECTIVE = "1600px";
export const HERO_ENTRANCE_PERSPECTIVE_ORIGIN = "50% 78%";

export const HERO_CONTENT_ENTRANCE: HeroEntranceConfig = {
  rotateZ: 0,
  originX: 0,
  originY: 200,
  originZ: -280,
};

export const HERO_TICKER_ENTRANCE: HeroEntranceConfig = {
  rotateZ: 0,
  originX: 0,
  originY: 240,
  originZ: -300,
};

export const HERO_ENTRANCE_SCROLL_DELAY = HERO_ENTRANCE_DELAY + HERO_ENTRANCE_DURATION;

export function createHeroEntranceVariants(
  reducedMotion: boolean,
  finalScale = HERO_ENTRANCE_FINAL_SCALE,
  withSettled = false,
  extraDelay = 0,
): Variants {
  const settledState = {
    opacity: 1,
    scale: 1,
    x: 0,
    y: 0,
    z: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    filter: "blur(0px)",
    transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1] as const },
  };

  if (reducedMotion) {
    return {
      hidden: { opacity: 0, scale: 0.96 },
      visible: ({ rotateZ }: HeroEntranceConfig) => ({
        opacity: 1,
        scale: 1,
        rotateZ: withSettled ? 0 : rotateZ,
        transition: { delay: HERO_ENTRANCE_DELAY + extraDelay, duration: 0.35, ease: "easeOut" },
      }),
      ...(withSettled ? { settled: settledState } : {}),
    };
  }

  return {
    hidden: ({ originX, originY, originZ, rotateZ }: HeroEntranceConfig) => ({
      opacity: 0,
      scale: 0.08,
      x: originX,
      y: originY,
      z: originZ,
      rotateX: 68,
      rotateY: originX > 0 ? -22 : originX < 0 ? 22 : 0,
      rotateZ: rotateZ * 0.25,
      filter: "blur(12px)",
    }),
    visible: ({ rotateZ }: HeroEntranceConfig) => ({
      opacity: 1,
      scale: finalScale,
      x: 0,
      y: 0,
      z: 0,
      rotateX: 0,
      rotateY: 0,
      rotateZ,
      filter: "blur(0px)",
      transition: {
        delay: HERO_ENTRANCE_DELAY + extraDelay,
        duration: HERO_ENTRANCE_DURATION,
        ease: [0.16, 1, 0.3, 1],
      },
    }),
    ...(withSettled ? { settled: settledState } : {}),
  };
}

export const HERO_ENTRANCE_SHINE_DELAY = `${HERO_ENTRANCE_DELAY + HERO_ENTRANCE_DURATION}s`;
